import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import NavBar from './NavBar';
import Breadcrumb from './Breadcrumb';
import useWindowSize from '../../hooks/useWindowSize';
import useOutsideClick from '../../hooks/useOutsideClick';
import usePageTitle from '../../hooks/usePageTitle';
import { useModuloControle } from '../../contexts/ModuloControleContext';
import { ConfigContext } from '../../contexts/ConfigContext';
import * as actionType from '../../store/actions';

const ResgateXmlLayout = ({ children }) => {
  const { contaBloqueada, notificacao } = useModuloControle();
  const location = useLocation();
  const windowSize = useWindowSize();
  const ref = useRef();
  const configContext = useContext(ConfigContext);
  const { collapseMenu, layout, subLayout, headerFixedLayout } = configContext.state;
  const { dispatch } = configContext;
  
  // Atualiza o título da página automaticamente
  usePageTitle();

  useOutsideClick(ref, () => {
    if (collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU });
    }
  });

  useEffect(() => {
    if (windowSize.width > 992 && windowSize.width <= 1024 && layout !== 'horizontal') {
      dispatch({ type: actionType.COLLAPSE_MENU });
    }
    if (layout === 'horizontal' && windowSize.width < 992) {
      dispatch({ type: actionType.CHANGE_LAYOUT, layout: 'vertical' });
    }
  }, [windowSize]);

  const containerClasse = ['pcoded-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    containerClasse.push('container');
  }

  const handleMobileClick = () => {
    if (windowSize.width < 992 && collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU });
    }
  };

  const navigation = (
    <div className={['nav-outside', collapseMenu && 'mob-backdrop', headerFixedLayout && 'mob-fixed'].filter(Boolean).join(' ')} ref={ref}>
      <Navigation />
      <NavBar />
    </div>
  );

  return (
    <>
      {windowSize.width < 992 ? navigation : (
        <>
          <Navigation />
          <NavBar />
        </>
      )}
      <div className='pcoded-main-container mt-3 pl-3' onClick={handleMobileClick}>
        <div className={containerClasse.join(' ')}>

          <div className='pcoded-content'>
            <div className='pcoded-inner-content'>
              {!contaBloqueada && location.pathname.indexOf('inicio') === -1 && notificacao}
              <Breadcrumb />
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResgateXmlLayout;
